import { Action, createReducer, on } from '@ngrx/store';
import { removeSession, setSession } from '../actions/session.actions.';
import { UserSession } from './../models/session.model';

export const initialState: UserSession | undefined = undefined;

export const sessionReducer = createReducer<UserSession | undefined, Action>(
  initialState,
  on(setSession, (state, session) => {
    return { ...state, ...session };
  }),
  on(removeSession, (state, session) => {
    return Object.assign({}, initialState);
  })
);
